// 統一的「dev-only」工具集中地。Production build 透過 NODE_ENV gate 完全靜音,
// 不會出現在使用者瀏覽器的 console 中。

export const IS_DEV = typeof process !== 'undefined' && process?.env?.NODE_ENV !== 'production';

// 產生帶固定 tag 的 console.warn helper,呼叫端只需保留 tag(模組名稱),
// 不需自行覆寫 NODE_ENV gate / typeof console 等防禦碼。
export const createDevWarn = tag => (...args) => {
	if (!IS_DEV) {
		return;
	}

	if (typeof console === 'undefined' || typeof console.warn !== 'function') {
		return;
	}

	console.warn(tag, ...args);
};
